import React from "react";
import "animate.css";
import "./SmartSurveillance.css"

function SmartSurveillance() {

  return (
    <>
      {/* Hero Section */}
      <div className="container-fluid bg-breadcrumb15">
        <div className="bg-breadcrumb-single"></div>

        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Smart Surveillance Solutions
          </h4>

          <p
            className="text-white wow fadeInUp"
            data-wow-delay="0.2s"
            style={{
              maxWidth: "720px",
              margin: "0 auto",
              fontSize: "18px",
            }}
          >

          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container-fluid p-0">

        {/* Intro Section */}
        {/* Smart Surveillance Overview */}

        <section className="py-5 bg-white">

          <div className="container">

            <div className="row align-items-center">

              <div className="col-lg-6">

                <h2
                  className="fw-bold mb-4"
                  style={{
                    color: "#021bf5",
                    fontSize: "34px"
                  }}
                >
                  Smart Surveillance:
                  <br />
                  From Passive Recording
                  to Proactive Intelligence
                </h2>

                <p className="mb-4">

                  Traditional surveillance systems are designed to record events after they occur.
                  Today's organizations require intelligent surveillance solutions that can detect threats,
                  improve safety, and provide actionable insights in real time. By combining Artificial Intelligence (AI),
                  Deep Learning, Edge Computing, and IoT integration,
                  Smart Surveillance transforms video monitoring from passive observation into proactive intelligence.
                </p>

                <p>

                  At Celersoft, we help organizations deploy AI-powered surveillance solutions that enhance security,
                  strengthen compliance, improve operational
                  efficiency, and enable faster decision-making across industrial, commercial, and public environments.

                </p>

              </div>

              <div className="col-lg-6">

                <img
                  src="assets/img/smartsurv2.jpg"
                  alt="Smart Surveillance"
                  className="img-fluid rounded-4 shadow-lg"
                />

              </div>

            </div>

          </div>

        </section>


        <section className="surveillance-evolution py-5">

          <div className="container">

            <div className="text-center mb-5">
              <h2 className="fw-bold">
                From Passive Monitoring to Active Intelligence
              </h2>

              <p className="lead">
                Traditional surveillance only records events.
                AI-powered surveillance understands, predicts,
                and responds in real time.
              </p>
            </div>

            <div className="row align-items-center g-4">

              {/* Traditional */}

              <div className="col-lg-5">

                <div className="evolution-card traditional-card">

                  <div className="evolution-badge">
                    Traditional Surveillance
                  </div>

                  <ul>
                    <li>Records incidents after they occur</li>
                    <li>Manual monitoring required</li>
                    <li>Reactive security approach</li>
                    <li>Video storage focused</li>
                    <li>Time-consuming investigations</li>
                  </ul>

                </div>

              </div>

              {/* Center Arrow */}

              <div className="col-lg-2 text-center">

                <div className="evolution-arrow">

                  →

                </div>

              </div>

              {/* Smart */}

              <div className="col-lg-5">

                <div className="evolution-card smart-card">

                  <div className="evolution-badge">
                    Smart Surveillance
                  </div>

                  <ul>
                    <li>Detects threats in real time</li>
                    <li>AI-powered analytics</li>
                    <li>Predictive intelligence</li>
                    <li>Instant alerts & automation</li>
                    <li>Proactive decision-making</li>
                  </ul>

                </div>

              </div>

            </div>

          </div>

        </section>

        {/* Industry Applications */}

        <section className="surveillance-matrix-section py-5">

          <div className="container">

            <div className="text-center mb-5">

              <h2 className="matrix-title">
                Smart Surveillance Across Industries
              </h2>

              <p className="matrix-subtitle">
                AI-powered surveillance solutions deliver real-time
                visibility, proactive monitoring, compliance management,
                and operational intelligence across diverse environments.
              </p>

            </div>
            <div className="row mb-5">

              <div className="col-12">

                <img
                  src="assets/img/surveillance-industries.png"
                  alt="Smart Surveillance Industries"
                  className="img-fluid surveillance-banner"
                />

              </div>

            </div>

            <div className="row g-4">

              {/* PPE */}

              <div className="col-lg-6">
                <div className="matrix-card">

                  <div className="matrix-icon">🦺</div>

                  <h3>
                    Automated Safety &
                    PPE Compliance
                  </h3>

                  <p>
                    AI-powered video analytics automatically verifies the use of Personal Protective Equipment (PPE),
                    helping organizations
                    enforce safety regulations, reduce workplace incidents, and improve compliance across operational sites.
                  </p>

                  <div className="matrix-line"></div>

                </div>
              </div>

              {/* Security */}

              <div className="col-lg-6">
                <div className="matrix-card">

                  <div className="matrix-icon">🔒</div>

                  <h3>
                    High-Level Security &
                    Identification
                  </h3>

                  <p>
                    AI-enabled surveillance helps identify unauthorized access, suspicious activity,
                    perimeter breaches, and security threats in real time, improving situational awareness and response
                    capabilities.
                  </p>

                  <div className="matrix-line"></div>

                </div>
              </div>

              {/* Hazard */}

              <div className="col-lg-6">
                <div className="matrix-card">

                  <div className="matrix-icon">⚠️</div>

                  <h3>
                    Predictive Hazard
                    Monitoring
                  </h3>

                  <p>
                    Smart surveillance systems continuously monitor equipment, restricted zones, and workforce activities
                    to identify potential hazards before they become critical incidents.
                    Real-time alerts support faster response and improved risk management.
                  </p>

                  <div className="matrix-line"></div>

                </div>
              </div>

              {/* Crowd */}

              <div className="col-lg-6">
                <div className="matrix-card">

                  <div className="matrix-icon">👥</div>

                  <h3>
                    Crowd & Flow
                    Management
                  </h3>

                  <p>
                    Real-time occupancy monitoring, people counting, and crowd movement
                    analysis help organizations improve public safety, optimize resource allocation, and enhance
                    visitor experiences.
                  </p>

                  <div className="matrix-line"></div>

                </div>
              </div>

              {/* Workflow */}

              <div className="col-lg-6">
                <div className="matrix-card">

                  <div className="matrix-icon">🚚</div>

                  <h3>
                    Logistics & Workflow
                    Optimization
                  </h3>

                  <p>
                    Advanced video analytics provides visibility into equipment utilization, vehicle movement,
                    material handling,
                    and workforce operations, enabling organizations to optimize workflows and improve operational efficiency.
                  </p>

                  <div className="matrix-line"></div>

                </div>
              </div>

              {/* Rules */}

              <div className="col-lg-6">
                <div className="matrix-card">

                  <div className="matrix-icon">📍</div>

                  <h3>
                    Intelligent Rules
                    Management
                  </h3>

                  <p>
                    Automated rule-based monitoring enables organizations to detect policy
                    violations, restricted-area access, loitering, and abnormal behavior patterns while reducing manual
                    intervention.
                  </p>

                  <div className="matrix-line"></div>

                </div>
              </div>

            </div>

          </div>

        </section>


        <section className="ai-vision-section py-5">

          <div className="container">

            <div className="text-center mb-5">

              <h2 className="fw-bold">
                What AI Sees Beyond the Camera
              </h2>

              <p className="lead">
                Modern surveillance systems do more than capture footage.
                They understand environments, detect anomalies, and trigger intelligent actions.
              </p>

            </div>

            <div className="row justify-content-center align-items-center">

              <div className="col-lg-12">

                <div className="ai-flow-wrapper">

                  <div className="ai-flow-card">
                    <div className="flow-icon">📷</div>
                    <h5>Video Feed</h5>
                  </div>

                  <div className="flow-line"></div>

                  <div className="ai-flow-card">
                    <div className="flow-icon">👁️</div>
                    <h5>Object Detection</h5>
                  </div>

                  <div className="flow-line"></div>

                  <div className="ai-flow-card">
                    <div className="flow-icon">🧠</div>
                    <h5>Behavior Analysis</h5>
                  </div>

                  <div className="flow-line"></div>

                  <div className="ai-flow-card">
                    <div className="flow-icon">⚠️</div>
                    <h5>Threat Recognition</h5>
                  </div>

                  <div className="flow-line"></div>

                  <div className="ai-flow-card">
                    <div className="flow-icon">🚨</div>
                    <h5>Automated Response</h5>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>


        {/* Intelligence Pipeline */}
        <section
          className="py-5"
          style={{
            background:
              "linear-gradient(135deg, #f7fafb 0%, #f7fafb 100%)",
            color: "black",
          }}
        >
          <div className="container">

            <div className="text-center mb-5 wow fadeInUp">
              <h2 className="fw-bold text-black">
                Intelligence Pipeline
              </h2>

              <p
                className="mx-auto"
                style={{ maxWidth: "750px" }}
              >
                Split-second response architecture powered
                by AI, Edge Computing, and IoT integration.
              </p>
            </div>

            <div className="row g-4 justify-content-center">

              {/* AI */}
              <div className="col-lg-4">
                <div
                  className="rounded-4 p-4 h-100 text-center"
                  style={{
                    background:
                      "rgba(255,255,255,0.05)",
                    border:
                      "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  {/* <div
                    className="mx-auto mb-4 rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: "240px",
                      height: "240px",
                      background:
                        "rgba(0,255,255,0.1)",
                      fontSize: "36px",
                    }}
                  >
                    🧠
                  </div> */}

                  <div
                    className=" pipeline-circle mx-auto mb-4 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
                    style={{
                      width: "300px",
                      height: "300px",

                    }}
                  >
                    <img
                      src="assets/img/ai_deep.jpg"
                      alt="AI Surveillance"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                      }}
                    />
                  </div>

                  <h3 className="fw-bold text-black">
                    AI & Deep Learning
                  </h3>

                  <p className="text-black">
                    Advanced algorithms analyze video
                    streams in real time to recognize objects, behaviors, safety violations, and potential threats with
                    high accuracy.
                  </p>
                </div>
              </div>

              {/* Edge */}
              <div className="col-lg-4">
                <div
                  className="rounded-4 p-4 h-100 text-center"
                  style={{
                    background:
                      "rgba(255,255,255,0.05)",
                    border:
                      "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <div
                    className=" pipeline-circle mx-auto mb-4 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
                    style={{
                      width: "300px",
                      height: "300px",

                    }}
                  >
                    <img
                      src="assets/img/ai_deep4.jpg"
                      alt="AI Surveillance"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                      }}
                    />
                  </div>

                  <h3 className="fw-bold text-black">
                    Edge Computing
                  </h3>

                  <p className="text-black">
                    Processing data at the edge reduces
                    latency and enables immediate responses to critical events, ensuring faster and more reliable
                    decision-making.
                  </p>
                </div>
              </div>

              {/* IoT */}
              <div className="col-lg-4">
                <div
                  className="rounded-4 p-4 h-100 text-center"
                  style={{
                    background:
                      "rgba(255, 255, 255, 0.05)",
                    border:
                      "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <div
                    className="pipeline-circle mx-auto mb-4 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
                    style={{
                      width: "300px",
                      height: "300px",

                    }}
                  >
                    <img
                      src="assets/img/ai_deep3.jpg"
                      alt="AI Surveillance"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                      }}
                    />
                  </div>

                  <h3 className="fw-bold text-black">
                    IoT Integration
                  </h3>

                  <p className="text-black">
                    Integration with sensors, access control systems, alarms, and operational
                    technologies creates a connected ecosystem that enhances visibility, automation, and situational
                    awareness.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>
        <div className="row g-4 align-items-stretch">

          <div className="col-lg-6">
            <img
              src="assets/img/smart1.png"
              alt="Paradigm Shift"
              className="img-fluid smart-img"
            />
          </div>

          <div className="col-lg-6">
            <img
              src="assets/img/smart2.png"
              alt="Four Pillars"
              className="img-fluid smart-img"
            />
          </div>

        </div>

        {/* CTA */}
        {/* PARTNER */}
        <section className="py-5">
          <div className="container">

            <div className="row align-items-center g-5">

              <div className="col-lg-5">

                <img
                  src="assets/img/partner.png"
                  alt="Partnership"
                  className="img-fluid1 rounded-4 shadow"
                  style={{
                    width: "100%",
                    height: "300px",
                    objectFit: "cover",
                    borderRadius: 24
                  }}
                
                />

              </div>

              <div className="col-lg-7">

                <span className="private-tag">
                  Partner with Celersoft
                </span>

                <h2 className="private-title mt-2">
                  Build Future-Ready Connectivity
                </h2>

                <p className="private-text">
                  Celersoft provides end-to-end Private 5G services and solutions, from network design and
                  deployment to integration and ongoing support. Our experts help organizations build
                  future-ready connectivity platforms that enable smarter operations, stronger security,
                  and sustainable business growth.
                </p>

              </div>

            </div>

          </div>
        </section>
        {/* Footer Start */}
        <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
          <div className="container pt-4">
            <div className="row g-5">
              <div className="col-md-6 col-lg-6 col-xl-3">
                <p>
                  <span style={{ fontSize: 20 }}>
                    <em>
                      <strong>USA</strong>
                    </em>
                  </span>
                </p>
                <p>
                  <i className="fas fa-map-marker me-1" />1500 S Dairy Ashford Rd
                  <br />
                  Ste 355 Houston
                  <br />
                  TX 77077
                </p>
              </div>

              <div className="col-md-6 col-lg-6 col-xl-3">
                <div className="single_address">
                  <p>
                    <em>
                      <span style={{ fontSize: 20 }}>
                        <strong>CANADA</strong>
                      </span>
                    </em>
                  </p>
                  <p>
                    <i className="fas fa-map-marker me-1" /> 998 Loft Court,
                    <br />
                    London, Ontario
                    <br />
                    N6G0J9
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-6 col-xl-3">
                <div className="single_address">
                  <p>
                    <span style={{ fontSize: 20 }}>
                      <em>
                        <strong>INDIA</strong>
                      </em>
                    </span>
                  </p>
                  <p>
                    <i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor,
                    <br />
                    Arjun Plaza, SP Road,
                    <br />
                    Nizampet, Hyderabad,
                    <br />
                    Telangana - 500085
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-6 col-xl-3">
                <div className="footer-item d-flex flex-column">
                  <a href="mailto:info@celersoft.com">
                    <i className="fas fa-envelope me-2" /> info@celersoft.com
                  </a>
                  <a href="tel:+18322258898">
                    <i className="fas fa-phone me-2" /> (+1) 832-225-8898
                  </a>
                  <hr />
                  <div className="d-flex align-items-center">
                    <a
                      className="btn btn-light btn-md-square me-2"
                      href="https://www.facebook.com/celersoft"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-light btn-md-square me-0"
                      href="https://www.linkedin.com/company/celersoft/"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid copyright py-3">
          <div className="container">
            <div className="row g-4 align-items-center">
              <div className="col-md-6 text-center text-md-start mb-md-0">
                <span className="text-body">
                  <i className="fas fa-copyright text-light me-1" />
                  2024 Celersoft. All rights reserved.
                </span>
              </div>
              <div className="col-md-6 text-center text-md-end text-body">
                {/* <a
                className="border-bottom text-primary"
                href="https://htmlcodex.com"
              >
                HTML Codex
              </a>{" "}
              Distributed By{" "}
              <a
                className="border-bottom text-primary"
                href="https://themewagon.com"
              >
                ThemeWagon
              </a> */}
              </div>
            </div>
          </div>
        </div>

        <button
          className="btn btn-primary btn-lg-square back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <i className="fa fa-arrow-up" />
        </button>
        {/* Footer End */}

      </div>
    </>
  );
}

export default SmartSurveillance;